import { clampMetaDescription } from './seoDefaults';

const TITLE_MAX = 78;
const TRADES_META_MAX = 158;

export function tradesAreaClickyTitle(area) {
  if (!area || !area.name) return '';
  const core = `${area.name} trades: web design & dev | £0 Upfront · low monthly | WebCodeCraft`;
  if (core.length <= TITLE_MAX) return core;
  const short = `${area.name} trades | £0 Upfront · monthly care | WebCodeCraft`;
  return short.length <= TITLE_MAX ? short : `${area.name} | £0 Upfront · WebCodeCraft`;
}

export function tradesAreaMetaDescription(area) {
  if (!area || !area.name) return '';
  if (String(area.slug).toLowerCase() === 'ipswich') {
    return clampMetaDescription(
      '£19.99/mo for trade websites in Ipswich & Suffolk—bespoke builds, not WordPress. £0 upfront; SSL & local SEO. WebCodeCraft.',
      TRADES_META_MAX
    );
  }
  return clampMetaDescription(
    `FREE SEO audit · Bespoke websites for trades in ${area.name}, ${area.region}—custom builds, not WordPress. £0 upfront; low monthly hosting & care. SSL, local SEO. WebCodeCraft.`
  );
}

export function tradesNicheClickyTitle(niche, area) {
  if (!niche || !area || !area.name) return '';
  const primary = `${niche.tradeLabel} ${area.name} | £0 Upfront · Low Monthly | WebCodeCraft`;
  if (primary.length <= TITLE_MAX) return primary;
  return `${niche.tradeLabel} · ${area.name} | £0 Upfront | WebCodeCraft`;
}

export function tradesNicheMetaDescription(niche, area) {
  if (!niche || !area) return '';
  return clampMetaDescription(
    `FREE SEO audit · Pay monthly sites for ${niche.tradeLabel.toLowerCase()} in ${area.name}: bespoke code, not WordPress. £0 upfront, SSL, ${area.region}. WebCodeCraft.`
  );
}
